import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-da78b22a")

_pushScopeId("data-v-da78b22a")
const _hoisted_1 = { class: "filter-container" }
const _hoisted_2 = {
  role: "group",
  class: "form-group"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { class: "" }, " 지역 조회 ", -1)
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "저수지 검색")
], -1)
const _hoisted_6 = { class: "search-result-container" }
const _hoisted_7 = { class: "point-info-card" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  id: "mapContainer",
  style: {"width":"100%","height":"100%"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Loading = _resolveComponent("Loading")
  const _component_WaterQuality = _resolveComponent("WaterQuality")
  const _component_WaterLevel = _resolveComponent("WaterLevel")

  return (_openBlock(), _createBlock("div", {
    style: [{"position":"relative"}, _ctx.fullHeight]
  }, [
    _createVNode(_component_Loading, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("select", {
          class: "form-control",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadSpots && _ctx.loadSpots(...args)))
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.regionGeoJson, (option, key) => {
            return (_openBlock(), _createBlock(_Fragment, null, [
              (typeof option === 'object')
                ? (_openBlock(), _createBlock("option", _mergeProps({
                    key: 0,
                    value: option.value
                  }, option.attrs, {
                    disabled: option.disabled,
                    selected: option.value === _ctx.value,
                    "data-key": key,
                    key: option.value
                  }), _toDisplayString(option.label || option.value), 17, ["value", "disabled", "selected", "data-key"]))
                : (_openBlock(), _createBlock("option", {
                    value: option,
                    selected: option === _ctx.value,
                    "data-key": key,
                    key: key
                  }, _toDisplayString(option), 9, ["value", "selected", "data-key"]))
            ], 64))
          }), 256))
        ], 32)
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("input", {
          type: "text",
          class: "form-control",
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeSearchKey && _ctx.changeSearchKey(...args)))
        }, null, 32)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchResults, (searchPoint) => {
            return (_openBlock(), _createBlock("li", {
              key: searchPoint.id,
              onClick: ($event: any) => (_ctx.gotoPoint(searchPoint))
            }, [
              _createVNode("div", _hoisted_7, [
                _createVNode("p", null, _toDisplayString(searchPoint.name), 1),
                _createVNode("span", null, _toDisplayString(searchPoint.address), 1)
              ])
            ], 8, ["onClick"]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_WaterQuality, { waterQuality: _ctx.waterQuality }, null, 8, ["waterQuality"]),
    _createVNode(_component_WaterLevel, { waterLevel: _ctx.waterLevel }, null, 8, ["waterLevel"]),
    _hoisted_8
  ], 4))
})